import client from '../base-api';

const serviceURL = '/user';

const userService = {

  // Basic information
  current(): Promise<any> {
    return client.get(serviceURL+'/current');
  },
  getUserNextNumber() {
    return client.get(`${serviceURL}/next-number`);
  },
  getUsers(filterData: any) {
    return client.get(`${serviceURL}`, {params: filterData});
  },
  getUser(userId: number) {
    return client.get(`${serviceURL}/${userId}`);
  },
  postUser(userData: any) {
    return client.post(`${serviceURL}`, userData);
  },
  putUser(userData: any, userId: number) {
    return client.put(`${serviceURL}/${userId}`, userData);
  },
  deleteUser(userId: number) {
    return client.delete(`${serviceURL}/${userId}`);
  },

  // Digital signature
  saveDigitalSignature(data: any) {
    return client.post(`${serviceURL}/digital-signature`, data);
  },


  // Qualifications
  getQualifications(userId: number) {
    return client.get(`${serviceURL}/qualification-list/${userId}`);
  },
  getSingleQualification(qualificationId: number) {
    return client.get(`${serviceURL}/qualification-details/${qualificationId}`);
  },
  postQualification(userId: number, data: any) {
    return client.post(`${serviceURL}/qualification-create/${userId}`, data);
  },
  putQualification(userId: number, qualificationId: number,  data: any) {
    return client.put(`${serviceURL}/qualification-update/${userId}/${qualificationId}`, data);
  },
  deleteQualification(id: number) {
    return client.delete(`${serviceURL}/qualification-delete/${id}`);
  },


  // Further education
  getFurtherEducations(userId: number) {
    return client.get(`${serviceURL}/further-education-list/${userId}`);
  },
  getSingleFurtherEducation(educationId: number) {
    return client.get(`${serviceURL}/further-education-details/${educationId}`);
  },
  postFurtherEducation(userId: number, data: any) {
    return client.post(`${serviceURL}/further-education-create/${userId}`, data);
  },
  putFurtherEducation(userId: number, educationId:number,  data: any) {
    return client.put(`${serviceURL}/further-education-update/${userId}/${educationId}`, data);
  },
  deleteFurtherEducation(id: number) {
    return client.delete(`${serviceURL}/further-education-delete/${id}`);
  },


  // Student working days
  getStudentWorkingDays(userId: number) {
    return client.get(`${serviceURL}/student-working-days-list/${userId}`);
  },
  getSingleStudentWorkingDay(workingDayId: number) {
    return client.get(`${serviceURL}/student-working-day-details/${workingDayId}`);
  },
  postStudentWorkingDays(userId: number, data: any) {
    return client.post(`${serviceURL}/student-working-day-create/${userId}`, data);
  },
  putStudentWorkingDays(userId: number, workingDayId:number,  data: any) {
    return client.put(`${serviceURL}/student-working-day-update/${userId}/${workingDayId}`, data);
  },
  getDaysInMonth(year:number, month:number){
    return client.get(`${serviceURL}/student-days-in-month/${year}/${month}`);
  },

};

export default userService;
